<template>
  <div>
    <basic-container>
      <el-form ref="form" :model="projectDynamicForm">
        <!-- 工程项目名称选择 -->
        <el-form-item label="工程项目名称">
          <div style="display: flex; align-items: center;">
            <el-input v-model="projectDynamicForm.name" placeholder="请输入工程项目名称"
              style="flex: 1; min-width: 200px;"></el-input>
          </div>
        </el-form-item>

        <!-- 动态表单配置部分 -->
        <el-form-item label="工程服务阶段">
          <el-card v-for="(stage, stageIndex) in projectStages" :key="stageIndex">
            <el-table :data="stage.forms" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="stageName" label="服务阶段名称" min-width="150">
                <template v-slot="scope">
                  <el-input v-model="scope.row.stageName" placeholder="请输入服务阶段名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sort" label="排序" min-width="200">
                <template v-slot="scope">
                  <el-input-number v-model="scope.row.sort" placeholder="请输入排序"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="表单配置" min-width="900">
                <template v-slot="scope">
                  <el-table :data="scope.row.formFields" border style="width: 100%">
                    <el-table-column label="字段名称">
                      <template v-slot="innerScope">
                        <el-input v-model="innerScope.row.fieldName" placeholder="字段名称"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="控件类型">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.inputType" placeholder="请选择控件类型">
                          <el-option v-for="type in inputTypes" :key="type.id" :label="type.name"
                            :value="type.id"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="数据源">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.dataSource" placeholder="请选择数据源">
                          <el-option v-for="source in dataSources" :key="source.id" :label="source.valueName"
                            :value="source.id"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="是否为空">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.isNull">
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <el-table-column label="上传示例图片" align="center">
                      <template v-slot="innerScope">
                        <ImageUpload action="#" :multiple="true" :inTable="true" :limit="1"
                          @uploaded="(urls) => handleUploaded(urls, stageIndex, innerScope.$index)"
                          :uploaded-images="innerScope.row.picUrl" />
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item align="center">
          <el-button type="primary" icon="el-icon-arrow-left" @click="back">返回上一页</el-button>
        </el-form-item>
      </el-form>
    </basic-container>
  </div>
</template>

<script>
import { findEngineeringDynamicId, findDataSourceAll, findDataSourceFields } from "@/api/work/engineeringProject/projectDynamic";
import ImageUpload from "@/components/imageUpload/ImageUpload";

export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      projectDynamicForm: { name: '' },
      projectStages: [],
      inputTypes: [],
      dataSources: [],
      additionalFields: {}, // 用于存储其他字段
    };
  },
  created() {
    // 获取输入控件类型
    findDataSourceFields().then(res => {
      this.inputTypes = JSON.parse(res.data);
    });

    // 获取数据源
    findDataSourceAll().then(res => {
      this.dataSources = JSON.parse(res.data).rows;
    });

    // 获取项目详情
    const projectId = this.$route.query.id;
    findEngineeringDynamicId(projectId).then(res => {
      const data = JSON.parse(res.data).rows[0];
      console.log('data::: ', data);
      // 将数据赋值给 projectStages 和 additionalFields
      this.projectDynamicForm.name = data.name;
      this.additionalFields = { /* 其他字段 */ ...data }; // 假设其他字段在data对象中
      this.projectStages = data.list.map(stage => ({
        forms: [{
          stageName: stage.name,
          sort: stage.sort,
          formFields: stage.dynamicFormRequest.fields.map(field => ({
            fieldName: field.fieldName,
            inputType: this.inputTypes.find(type => type.id == field.inputType).id,
            dataSource: field.dataSource,
            isNull: field.isNull,
            // picUrl: field.picUrl || [],
            // 如果 picUrl 是字符串，转换为数组
            picUrl: (field.picUrl || '').split(',').filter(url => url).map(url => ({ url, name: url.substring(url.lastIndexOf('/') + 1) })),
          })),
        }],
      }));
    });
  },
  methods: {
    handleUploaded(urls, stageIndex, fieldIndex) {
      this.projectStages[stageIndex].forms[0].formFields[fieldIndex].picUrl = urls;
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
/* 可根据需求增加样式 */
</style>
